export default {
  getStatisticData() {
    return this.get('/oauth/goldplus/unsubscribe/statistic');
  },
};
